import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';

const WebCheckout = () => {
  const { token, bookingId } = useParams();
  const [confirmationCode, setConfirmationCode] = useState(bookingId || '');
  const [bookingDetails, setBookingDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (bookingId) {
      handleSearch();
    }
  }, [bookingId]);

  const handleSearch = async () => {
    if (!confirmationCode.trim()) {
      setError('Please enter a valid confirmation code.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');
    setBookingDetails(null);

    let formData = new FormData();
    formData.append('token', token);
    formData.append('confirmation_code', confirmationCode);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        url: `${params.baseURL}${params.endpoints.getBookingDetails}`,
        data: formData,
      });

      if (response.data.status === 'success') {
        setBookingDetails(response.data.data);
      } else {
        setError(response.data.message || 'Booking not found.');
      }
    } catch (err) {
      setError('Error fetching booking details.');
    } finally {
      setLoading(false);
    }
  };

  const handleCheckout = async () => {
    if (!bookingDetails) {
      setError('No booking details available to process checkout.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    let formData = new FormData();
    formData.append('token', token);
    formData.append('stay_booking_id', bookingDetails.stay_booking_id);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        url: `${params.baseURL}${params.endpoints.saveCheckout}`,
        data: formData,
      });

      if (response.data.status === 'success') {
        if (typeof window !== 'undefined' && window.Android && typeof window.Android.checkoutDone === 'function') {
          window.Android.checkoutDone();
        }        
        setSuccess('Checkout successful!');
        setBookingDetails(null);
        navigate('/home');
      } else {
        setError(response.data.message || 'Failed to process checkout.');
      }
    } catch (err) {
      setError('Error processing checkout.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Manage Check-out</title>
        <meta name="description" content="Manage booking check-out for guests." />
      </Helmet>

      <style>
        {`
          #main {
            margin-top:0;
            padding: 20px 12px;
          }
        `}
      </style>

      <div className="checkout-page">

        <div className="hms-header" style={{boxShadow:'none', border:'2px solid #ccc'}}>
          <div className='iwtb mb-0'>
            <img src={'/assets/img/icons/pointer_icon.svg'} alt="Profile" className="bd-icon" />
            <h1 className="ws-title m-0 text-uppercase">Manage Check-out</h1>
          </div>
        </div>

        <div className="booking-search-box">
          <div className="w-100 mb-2">
            <input
              type="text"
              className="form-control"
              placeholder="Enter Confirmation Code"
              style={{ height: '50px' }}
              value={confirmationCode}
              onChange={(e) => setConfirmationCode(e.target.value)}
            />
          </div>
          <div className="w-100">
            <button
              onClick={handleSearch}
              className="btn btn-black hlbtn w-100"
              disabled={loading}
            >
              {loading ? 'Searching...' : 'Search'}
            </button>
          </div>
        </div>

        {error && <p className="error text-danger">{error}</p>}
        {success && <p className="success text-success">{success}</p>}

        {bookingDetails && (
          <div className="booking-details">
            <div className="guest-assignments">
              <div className="guest-details-box">
                <div className="form-group gdsbx">
                  <div>
                    <div className='guest-name-box m-0'>
                      <img src="/assets/img/icons/pointer_icon.svg" alt="ID" className="bd-icon" />
                      <span className="bd-title m-0">Booking Details</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th className='p-0'>
                    <div className="guest-assignments">
                      <div className="guest-details-box">
                        <div className="form-group gdsbx">
                          <div>
                            <div className='guest-name-box m-0'>
                              <img src="/assets/img/icons/pointer_icon.svg" alt="ID" className="bd-icon" />
                              <span>Guest Name</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {bookingDetails.guests.map((guest, index) => (
                  <tr key={index}>
                    <td className='p-0'>
                      <div className="guest-assignments">
                        <div className="guest-details-box">
                          <div className="form-group gdsbx">
                            <div>
                              <div className='guest-name-box m-0'>
                                <img src="/assets/img/icons/pointer_icon.svg" alt="ID" className="bd-icon" />
                                <span>{guest.checkin_guest_name}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              onClick={handleCheckout}
              disabled={loading}
              className="btn btn-black hlbtn w-100"
            >
              {loading ? 'Processing...' : 'Checkout'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WebCheckout;
